<template>
  <div>
    <v-row>
      <v-col cols="6">
        <v-text-field v-model="htmlPage.title" label="ページ名" disabled />
      </v-col>
      <v-col cols="6">
        <v-chip v-if="htmlPage.published"> 公開 </v-chip>
        <v-chip v-else> 非公開 </v-chip>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="8">
        <v-text-field :value="permalink()" label="パーマリンク" disabled />
      </v-col>
      <v-col cols="4">
        <v-btn
          color="primary"
          tile
          outlined
          :to="`/admin/settings/html_pages/${this.$route.params.id}/basic_edit`"
        >
          基本設定を編集する
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  data () {
    return {
      // htmlPage: {},
    }
  },
  computed: {
    ...mapState({
      site: (state) => state.SiteStore.site,
      htmlPage: (state) => state.HtmlPageStore.htmlPage
    })
  },
  methods: {
    permalink () {
      return (
        this.site.initialDomainWithProtocol + '/lp/' + this.htmlPage.slug
      )
    }
  }
}
</script>
